import React from "react";
import { Link } from "react-router-dom";
import "../../css/terms.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();
  const sections = t("terms.sections", { returnObjects: true }) || [];

  return (
    <div className="terms-page">
      <Header />
      <main className="terms__main">
        <div className="terms__inner">
          <nav className="terms__breadcrumb" aria-label={t("terms.breadcrumbAria")}>
            <Link to="/" className="terms__breadcrumb-link">
              {t("terms.breadcrumb")}
            </Link>
          </nav>

          <h1 className="terms__title">{t("terms.title")}</h1>
          <p className="terms__lastUpdated">{t("terms.lastUpdated")}</p>
          <p className="terms__intro">{t("terms.intro")}</p>

          <div className="terms__sections">
            {Array.isArray(sections) &&
              sections.map((sec, idx) => (
                <section
                  key={`terms-sec-${idx}`}
                  className="terms-sec"
                  aria-labelledby={`terms-heading-${idx}`}
                >
                  <h2 id={`terms-heading-${idx}`} className="terms-sec__title">
                    {sec.title}
                  </h2>
                  <p className="terms-sec__text">{sec.body}</p>
                </section>
              ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
